import { render, staticRenderFns } from "./SalaryEffects.vue?vue&type=template&id=b562c030&"
import script from "./SalaryEffects.vue?vue&type=script&lang=js&"
export * from "./SalaryEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports